export const dateKeyFormat = 'YYYY-MM-DD'

export const eventTimeFormats = {
    fromStartTime: 'From-StartTime',
    startTime: 'StartTime',
    startTimeEndTime: 'StartTime-EndTime'
}